function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1",
  d: "M124.599 147.558a73.779 73.779 0 10-73.511-73.779 73.645 73.645 0 0073.511 73.779"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M21.527 316.386h202.509a16.176 16.176 0 0016.175-16.175V189.299a16.176 16.176 0 00-16.175-16.175H21.527a16.175 16.175 0 00-16.175 16.175v110.912a16.175 16.175 0 0016.175 16.175"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M217.036 517.599L15.382 536.177A16.174 16.174 0 00.76 553.767l10.175 110.446a16.176 16.176 0 0017.592 14.623l201.653-18.581a16.175 16.175 0 0014.623-17.591l-10.177-110.445a16.175 16.175 0 00-17.59-14.623"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M231.117 354.637l-201.35-21.662a16.175 16.175 0 00-17.813 14.352L.094 457.604a16.175 16.175 0 0014.352 17.813l201.346 21.661a16.175 16.175 0 0017.813-14.352l11.862-110.277a16.175 16.175 0 00-14.352-17.812"
})));
var SvgTandemBlocksLogo = function SvgTandemBlocksLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 245.563 678.905"
  }, props), _ref);
};
export default SvgTandemBlocksLogo;